export class CommonPlatformUtilities {
  /**
   * Get cookie utility function
   * @static
   * @public
   * @param cookieName {string}
   * @returns {number}
   */
  static getCookie(cookieName) {
    const cookiesArr = document.cookie.split(';');
    const dict = {};
    cookiesArr.forEach(function(cookie) {
      const name = cookie.split('=')[0];
      const value = cookie.split('=')[1];
      dict[name] = value;
    });

    return dict[cookieName];
  }

  /**
   * Get user's device type
   * @public
   * @returns {string}
   */
  static getDeviceType() {
    let {isAndroid, isIPad} = $.Device,
      isMobile = MOVE.Helper.isMobile();

    if (isMobile) return "phone";
    else if (isIPad) return "ipad";
    else if (isAndroid) return "android tablet";
    return "other";
  }

  /**
   * Get user's oeprating system
   * @public
   * @returns {string}
   */
  static getOSType() {
    let {platform} = navigator;
    if (platform.indexOf('iP') > -1) return "ios";
    else if (platform.indexOf('Android') > -1) return "android";
    else return "other";
  }

  /**
   * Scroll on click
   * @param eventElement
   * @param targetElement
   * @returns {void}
   */
  static scrollOnClick(eventElement) {
    const ldpForm = '.ldp-full-bleed-form',
      ldpNextElement = '#ldp-additional-info',
      ldpLazyLoadElementWrapper = '#homes-near-street-wrapper',
      qvForm = '.qv-sec-bottom-lead-form',
      is_ldp = ($(ldpForm).length > 0) ? true : false;

    $(eventElement).on('click', function () {
      if (is_ldp) {
        if ($(ldpLazyLoadElementWrapper).children().length > 0) {
          $('html, body').animate({
            scrollTop: $(ldpForm).offset().top - 50
          }, 1000);
        } else {
          $('html, body').animate({
            scrollTop: $(ldpNextElement).offset().top - 325
          }, 1000);
        }
      } else {
        $('html, body').animate({
          scrollTop: $(qvForm).offset().top - 50
        }, 1000);
      }
    });
  }

  /**
   * Phone number regular expression validation
   * @param val
   * @returns {boolean}
   */
  static phoneNumberValid(val) {
    const phoneRegex = '^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$';
    const regex = new RegExp(phoneRegex);
    return regex.test(val);
  }

  /**
   * Format phone number
   * @returns {void}
   */
  static formatPhone() {
    const $phoneInput = $('.st-contact-input');
    $phoneInput.on('keyup keypress input change', function () {
      if ((/^(?=.*[0-9])[- +()0-9]+$/.test($(this).val())) === false) $(this).val('');
      $(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d)+$/, "($1)$2-$3"));
    })
  }
}



// WEBPACK FOOTER //
// ./ldp/common_platform/utils.js